import React from 'react'

import { Link, NavLink } from 'react-router-dom';
import ProfileCartModal from './ProfileCartModal';

const SkeletonMenu = () => {
    return (
        <nav className="prof-sidebar__nav buildedPage-sidemenu buildedPage__skeleton-menu" style={{ minWidth: 'auto', border: 0, margin: 0, paddingLeft: 45 }}>
            <ul className="nav-list">
                <li className="nav-list__item">
                    <div style={{ marginLeft: 0, marginTop: 15, marginBottom: 15 }} />
                </li>
                <li className="nav-list__item">
                    <div style={{ marginLeft: 0, marginTop: 15, marginBottom: 15 }} />
                </li>
                <li className="nav-list__item">
                    <div style={{ marginLeft: 0, marginTop: 15, marginBottom: 15 }} />
                </li>
                <li className="nav-list__item">
                    <div style={{ marginLeft: 0, marginTop: 15, marginBottom: 15 }} />
                </li>
                <li className="nav-list__item">
                    <div style={{ marginLeft: 0, marginTop: 15, marginBottom: 15 }} />
                </li>
                <li className="nav-list__item">
                    <div style={{ marginLeft: 0, marginTop: 15, marginBottom: 15 }} />
                </li>
            </ul>
        </nav>
    )
}


// <li className="nav-list__item">
//     <ProfileCartModal />
// </li>
const SideMenuItems = ({ isLoadingUserData, logout, bonusData }) => {
    return (
        isLoadingUserData ?
            <SkeletonMenu />
            :
            <nav className="prof-sidebar__nav">
                <ul className="nav-list">
                    <li className="nav-list__item">
                        <NavLink to="/profile/orders" className="nav-list__link" activeClassName='active'>
                            <svg><use xlinkHref="#i_orders" /></svg>
                            <p>Мои заказы</p>
                        </NavLink>
                    </li>
                    <li className="nav-list__item">
                        <NavLink to="/profile" className="nav-list__link" exact activeClassName='active'>
                            <svg><use xlinkHref="#i_profile" /></svg>
                            <p>Профиль</p>
                        </NavLink>
                    </li>
                    {
                        // bonusData ?
                        //     <li className="nav-list__item">
                        //         <NavLink to="/profile/bonus" className="nav-list__link" activeClassName='active'>
                        //             <img src={process.env.REACT_APP_BACKEND + 'uploads/profile/' + bonusData.url_icon} alt='' />
                        //             <p>{bonusData.name_item}</p>
                        //         </NavLink>
                        //     </li>
                        //     :
                        //     ""
                    }
                    <li className="nav-list__item">
                        <NavLink to="/profile/wishlist" className="nav-list__link" activeClassName='active'>
                            <svg><use xlinkHref="#i_like" /></svg>
                            <p>Список желаний</p>
                        </NavLink>
                    </li>
                    {/*   <li className="nav-list__item">
                        <NavLink to="/profile/waiting-list" className="nav-list__link" activeClassName='active'>
                            <svg><use xlinkHref="#i_time" /></svg>
                            <p>Лист ожидания</p>
                        </NavLink>
                    </li>
                    */}
                    <li className="nav-list__item">
                        <NavLink to="/profile/viewed-products" className="nav-list__link" activeClassName='active'>
                            <svg><use xlinkHref="#i_eye2" /></svg>
                            <p>Просмотренные товары</p>
                        </NavLink>
                    </li>
                    <li className="nav-list__item">
                        <Link to='#' onClick={logout} className="nav-list__link">
                            <svg className="red"><use xlinkHref="#i_exit" /></svg>
                            <p>Выйти</p>
                        </Link>
                    </li>
                </ul>
            </nav>
    )
}

export default SideMenuItems